"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
var _exports$NETWORK_TICK;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RankingHomeCollectionEnum = exports.CollectionCategory = exports.NotificationType = exports.Device = exports.NETWORK_TICKERS = exports.NETWORK = void 0;
// ALL PROJECT
var NETWORK;
(function (NETWORK) {
  NETWORK["SOLANA"] = "SOLANA";
  NETWORK["NEAR"] = "NEAR";
  NETWORK["APTOS"] = "APTOS";
})(NETWORK = exports.NETWORK || (exports.NETWORK = {}));
exports.NETWORK_TICKERS = (_exports$NETWORK_TICK = {}, _defineProperty(_exports$NETWORK_TICK, NETWORK.APTOS, 'APT'), _defineProperty(_exports$NETWORK_TICK, NETWORK.SOLANA, 'SOL'), _defineProperty(_exports$NETWORK_TICK, NETWORK.NEAR, 'NEAR'), _exports$NETWORK_TICK);
// MOBILE
var Device;
(function (Device) {
  Device["Apple"] = "Apple";
  Device["Android"] = "Android";
})(Device = exports.Device || (exports.Device = {}));
// TODO: Create intefaces for all Notifications Types
var NotificationType;
(function (NotificationType) {
  NotificationType["NIGHTLY_CONNECT_REQUEST"] = "NIGHTLY_CONNECT_REQUEST";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
// INDEXER
var CollectionCategory;
(function (CollectionCategory) {
  CollectionCategory["PFP"] = "PFP";
  CollectionCategory["ART"] = "ART";
  CollectionCategory["MUSIC"] = "MUSIC";
  CollectionCategory["METAVERSE"] = "METAVERSE";
  CollectionCategory["GAMES"] = "GAMES";
  CollectionCategory["SPORTS"] = "SPORTS";
  CollectionCategory["NSFW"] = "NSFW";
  CollectionCategory["EARNING"] = "EARNING";
  CollectionCategory["UTILITY"] = "UTILITY";
  CollectionCategory["VIRTUAL_WORLDS"] = "VIRTUAL_WORLDS";
  CollectionCategory["TRADING_CARDS"] = "TRADING_CARDS";
  CollectionCategory["OTHER"] = "OTHER";
})(CollectionCategory = exports.CollectionCategory || (exports.CollectionCategory = {}));
// MARKETPLACE
var RankingHomeCollectionEnum;
(function (RankingHomeCollectionEnum) {
  RankingHomeCollectionEnum["BLOCKCHAIN"] = "BLOCKCHAIN";
  RankingHomeCollectionEnum["TIME"] = "TIME";
  RankingHomeCollectionEnum["CATEGORY"] = "CATEGORY";
})(RankingHomeCollectionEnum = exports.RankingHomeCollectionEnum || (exports.RankingHomeCollectionEnum = {}));